import * as React from "react";
import type { SVGProps } from "react";
const SvgDashboard2 = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 2H6a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h2a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4M6 3.5h2A2.5 2.5 0 0 1 10.5 6v3A2.5 2.5 0 0 1 8 11.5H6A2.5 2.5 0 0 1 3.5 9V6A2.5 2.5 0 0 1 6 3.5M18 2h-1a4 4 0 0 0 0 8h1a4 4 0 0 0 0-8m-1 1.5h1a2.5 2.5 0 0 1 0 5h-1a2.5 2.5 0 0 1 0-5M16 11h2a4 4 0 0 1 4 4v3a4 4 0 0 1-4 4h-2a4 4 0 0 1-4-4v-3a4 4 0 0 1 4-4m0 1.5a2.5 2.5 0 0 0-2.5 2.5v3a2.5 2.5 0 0 0 2.5 2.5h2a2.5 2.5 0 0 0 2.5-2.5v-3a2.5 2.5 0 0 0-2.5-2.5zM7 14H6a4 4 0 0 0 0 8h1a4 4 0 0 0 0-8m-1 1.5h1a2.5 2.5 0 0 1 0 5H6a2.5 2.5 0 0 1 0-5"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDashboard2;
